import { getApiBase, safeJson, unwrapArray } from "./http";
import type { EventLite, ShiftLite } from "../types";

export const fetchEventsApi = async (): Promise<EventLite[]> => {
    const base = getApiBase();
    const res = await fetch(`${base}/api/events`);
    if (!res.ok) return [];

    const data = await safeJson<any>(res);
    const arr = unwrapArray(data);

    return arr
        .map((e: any) => ({
            eventID: Number(e.eventID ?? e.EventID ?? e.id ?? e.ID),
            eventName: String(
                e.eventName ??
                e.EventName ??
                e.title ??
                e.Title ??
                `Event #${e.eventID ?? e.EventID ?? "?"}`
            ),
        }))
        .filter((e: EventLite) => Number.isFinite(e.eventID) && e.eventID > 0);
};

export const fetchShiftsForEventApi = async (
    eventId: number
): Promise<ShiftLite[]> => {
    const base = getApiBase();
    const res = await fetch(`${base}/api/events/${eventId}/shifts`);
    if (!res.ok) return [];

    const data = await safeJson<any>(res);
    const arr = unwrapArray(data);

    return arr
        .map((s: any) => ({
            shiftsID: Number(s.shiftsID),
            title: String(s.shiftsName),
            start: s.startTime ?? undefined,
            end: s.endTime ?? undefined,
        }))
        .filter((x: ShiftLite) => Number.isFinite(x.shiftsID) && x.shiftsID > 0);
};